export const getPricePerTicket = (codename: string): number => {
  if (codename === 'gassan_vip_tour') {
    return 3500
  }
  if (codename === 'diamond_polishing_experience_tour') {
    return 40000
  }
  if (codename === 'diamond_and_champagne_tour') {
    return 4500
  }
  return 0
}
